import styled, { css } from 'styled-components'

export const CheckboxContainer = styled.label<{ $disabled?: boolean }>`
  display: inline-flex;
  align-items: flex-start;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  gap: 0.5rem;

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.6;
    `}
`

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

export const StyledCheckbox = styled.div<{
  $checked?: boolean
  $disabled?: boolean
  $error?: boolean
  $size?: 'small' | 'medium' | 'large'
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => {
    switch ($size) {
      case 'small':
        return '16px'
      case 'large':
        return '24px'
      default:
        return '20px'
    }
  }};
  height: ${({ $size }) => {
    switch ($size) {
      case 'small':
        return '16px'
      case 'large':
        return '24px'
      default:
        return '20px'
    }
  }};

  &:hover {
    ${({ $disabled, $checked, theme }) =>
      !$disabled &&
      !$checked &&
      css`
        svg rect {
          stroke: ${theme.colors.primary[600]};
        }
      `}
  }
`

export const CheckboxLabel = styled.span<{ $error?: boolean }>`
  ${({ theme }) => theme.typography.variants['Heading/Heading-14-Semibold']};
  color: ${({ theme }) => theme.palette.gray[600]};
`
